import React from 'react'
import styled from '@emotion/styled'
import { hexColors } from '@mobi/settings/hexColors'
import { isMysteryComboBetType, isMysterySelection } from '@mobi/betslip/helpers/typeGuards'
import type { MysteryDetails, MysterySelection } from '@mobi/betslip/types'
import { Grid, GridCell } from '@mobi/component-library/Common/Grid'
import { Money } from '@core/Components/Text/Money'
import {
  AmountStyled,
  FlexiDisplayStyled,
} from '@core/Areas/Quickbet/Components/BetInvestment/Components/FlexiDisplay/FlexiDisplay.styles'
import { SingleSelectionStyled } from '@core/Areas/Quickbet/Components/BetSelectionInfo/Components/Common/Common.styles'
import { MysteryNoveltySelection } from './MysteryNoveltySelection'
import { MysteryComboSelection } from './MysteryComboSelection'

interface MysteryDisplaySelectionProps {
  selection: MysterySelection
  details: MysteryDetails
}

export const MysteryDisplaySelections = ({ selection, details }: MysteryDisplaySelectionProps) => {
  if (!isMysterySelection(selection)) {
    return null
  }

  if (!selection.bets) {
    return null
  }

  const bet = selection.bets[0]
  const isCombo = isMysteryComboBetType(selection)
  let selectionComponent

  if (isCombo) {
    selectionComponent = <MysteryComboSelection selection={selection} displayPill={true} />
  } else if (isMysteryNoveltyBetType(selection)) {
    selectionComponent = <MysteryNoveltySelection selection={selection} displayPill={true} />
  } else {
    selectionComponent = (
      <SingleSelectionStyled data-tid-mystery-selection=''>
        Mystery Selections <br />
        {bet.betLines[0].selections}
      </SingleSelectionStyled>
    )
  }

  return (
    <>
      {selectionComponent}
      {!isCombo && (
        <MysteryBetInvestmentStyled>
          <Grid padding='0.4rem'>
            <GridCell width='50%'>
              <FlexiDisplayStyled isActive={false}>
                <span>Spend</span>{' '}
                <AmountStyled amount={1}>
                  <Money amount={details.investmentWin} />
                </AmountStyled>
              </FlexiDisplayStyled>
            </GridCell>
            <GridCell width='50%'>
              <FlexiDisplayStyled isActive={false}>
                <span>Flexi</span> <AmountStyled amount={1}>{bet.divXAnnotations}</AmountStyled>
              </FlexiDisplayStyled>
            </GridCell>
          </Grid>
        </MysteryBetInvestmentStyled>
      )}
    </>
  )
}

// =============
// Local Helpers
// =============

function isMysteryNoveltyBetType(selection: MysterySelection): boolean {
  return selection.bets ? selection.productCode.toLowerCase() !== 'combo' : false
}

// ======
// Styles
// ======

const MysteryBetInvestmentStyled = styled.div({
  backgroundColor: hexColors.blueDiamond,
  color: hexColors.white,
  marginTop: '1rem',
  position: 'relative',
})
